import { Card, Col, Row } from 'antd';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { newCheckRole } from 'utils/tools';
// import PagesList from 'containers/Pages/List';
import { DynamicObjectType } from 'types/commons';
import { useSelector } from '@redux';

const MENUS = [
  {
    key: 'warehouseLocation',
    title: 'settings.warehouseLocation.title',
    description: 'settings.warehouseLocation.description',
    url: '/settings/warehouse-locations',
    roleType: 'locations',
    endpoint: '/locations',
  },
  // {
  //   key: 'packageConfigs',
  //   title: 'settings.packageConfigs.title',
  //   description: 'settings.packageConfigs.description',
  //   url: '/settings/packageConfigs',
  //   roleType: 'package-configs',
  // },
  // {
  //   key: 'keySettings',
  //   title: 'settings.keySettings.title',
  //   description: 'settings.keySettings.description',
  //   url: '/settings/keySettings',
  //   roleType: 'key-settings',
  // },
  {
    key: 'chainStores',
    title: 'settings.chainStores.title',
    description: 'settings.chainStores.description',
    url: '/settings/chainStores',
    roleType: 'chain-stores',
    endpoint: '/chain-stores',
  },
  // {
  //   key: 'debtComparison',
  //   title: 'settings.debtComparison.title',
  //   description: 'settings.debtComparison.description',
  //   url: '/settings/debtComparison',
  //   roleType: 'partner-debt',
  // },
  // {
  //   key: 'partnerConfigs',
  //   title: 'settings.partnerConfigs.title',
  //   description: 'settings.partnerConfigs.description',
  //   url: '/settings/partnerConfigs',
  //   roleType: 'partner-configs',
  // },
  {
    key: 'bannedCustomers',
    title: 'settings.bannedCustomers.title',
    description: 'settings.bannedCustomers.description',
    url: '/settings/bannedCustomers',
    roleType: 'customers\\?.+isBanned',
    endpoint: '/customers',
  },
  {
    key: 'locationStockChanges',
    title: 'settings.locationStockChanges.title',
    description: 'settings.locationStockChanges.description',
    url: '/settings/locationStockChanges',
    roleType: 'customers\\?.+isBanned',
    endpoint: '/location-stock-changes',
  },
  //   {
  //     key: 'locations',
  //     title: 'settings.stores.title',
  //     description: 'settings.stores.description',
  //     url: '/settings/stores',
  //     roleType: 'locations',
  //   },
  //  {
  //     key: 'manageSKUs',
  //     title: 'settings.sku.title',
  //     description: 'settings.sku.description',
  //     url: '/settings/manage-related-skus',
  //     // roleType: 'locations',
  //  },
];

const CardList = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.data) as DynamicObjectType;
  const onClick = (e) => {
    navigate(e.url);
  };

  return (
    <Row gutter={[16, 16]}>
      {MENUS.map((e: DynamicObjectType) =>
        newCheckRole(e?.endpoint, 'GET', user?.roles, user?.isSuperUser) ? (
          <Col xs={24} md={8} sm={12} key={e.key}>
            <Card
              onClick={() => onClick(e)}
              hoverable
              bordered={false}
              className="h-full"
            >
              <Card.Meta description={t(e.description)} title={t(e.title)} />
            </Card>
          </Col>
        ) : (
          <span />
        ),
      )}
    </Row>
  );
};

export default CardList;
